<!--P086-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">员工管理</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">工号</div>
      <input v-model="search.id" class="cs_input cs_radius_lg edtxt_info_search">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">姓名</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">状态</div>
      <web-select :options="STAFF_STATUS_QUERY"
                  @option-key="updateStatus"
                  v-model="search.statusName"
                  class="cs_input cs_radius_lg edtxt_info_search"></web-select>
      <button class="ui_btn_search_yellow btn_search" type="button" @click="btnSearch">查询</button>
    </div>
    <!--表格-->
    <div class="cs_margin_top div_search_result cs_padding_top">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加
        </button>
        <button @click="btnResetPsw" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">重置密码
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="280px">工号</th>
            <th width="280px">名称</th>
            <th width="224px">角色数量</th>
            <th width="256px">状态</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
            <td>{{index+1}}</td>
            <td><a @click.stop="$router.push({name:'StaffDetail', query: {num:item.staffNum}})">{{item.staffNum}}</a></td>
            <td>{{item.staffName}}</td>
            <td>{{item.roleCount}}</td>
            <td>{{STAFF_STATUS[item.isStop]}}</td>
          </tr>
          <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
            <td v-for="j in 5"></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="div_page_download">
        <!--上一页-->
        <button v-show="search.pagination>1" @click="showList(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="showList(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jump()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select";
  import {Page, PAGE_SIZE,STAFF_STATUS_QUERY,STAFF_STATUS} from "../../assets/utils/constants"
  import StorageConst from "../../assets/utils/StorageConst";
  export default {
    name: "StaffManage",
    components: {SearchSelect, WebSelect},
    data: function () {
      return {
        selectedId: "",
        selectedName: "",
        search: {
          id: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.STAFF_MANAGE,"id", ""),
          name: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.STAFF_MANAGE,"name", ""),
          statusId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.STAFF_MANAGE,"statusId", 0),
          statusName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.STAFF_MANAGE,"statusName", ""),
          pageJump: "",
          totalPage: "",
          pagination: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.STAFF_MANAGE,"pagination", 1)
        },
        orderList: [],
        PAGE_SIZE: PAGE_SIZE,
        STAFF_STATUS_QUERY: STAFF_STATUS_QUERY,
        STAFF_STATUS: STAFF_STATUS,
      }
    },
    created: function () {
      this.showList(this.search.pagination);
    },
    mounted: function () {
    },
    methods:{
      showList(pagination) {
        this.selectedId = "";
        this.selectedName = "";
        this.$ajax.staff.listStaff.bind(this)(this.search, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.orderList = list;
          this.setStoreItem(StorageConst.LOCAL_PAGE_LIST.STAFF_MANAGE, JSON.stringify(this.search));
        }, (data) => {
        }, true)
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.staffNum;
          this.selectedName = item.staffName;
        }else {
          this.selectedId = "";
          this.selectedName = "";
        }
      },
      btnSearch(){
        this.showList(1);
      },
      jump() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            this.showList(this.search.totalPage);
          }else {
            this.showList(this.search.pageJump);
          }
        }
      },
      btnResetPsw(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请选择员工");
          return
        }
        this.$alert("确认重置员工"+this.selectedName+"的密码吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.staff.resetPassword.bind(this)(this.selectedId, (data) => {
              this.$toast("重置成功");
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnAdd(){
        this.$router.push({name:'StaffAdd'});
      },
      updateStatus(key) {
        this.search.statusId = key;
      },
      failDefault() {
      },
      timeToDate(time){
        return this.isEmpty(time)?"":time.substring(0,10)
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/staff/StaffManage.vue